module.exports = __webpack_public_path__ + "e5867be147989e6e756be49e8186f9c0.MP3";